var _excluded = ["children", "disabled", "flyoutRef", "iconLeft", "iconSprite", "id", "onClick", "showIcon", "shouldHideLabel", "trigger"],
  _excluded2 = ["render", "label", "id", "className", "onClick"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { PureComponent, createRef } from 'react';
import { Button, ButtonWithIcon } from '@els/els-react--button';
import { Flyout } from '@els/els-react--flyout';
import { Icon } from '@els/els-react--icon';
import { ValidPropTypes, makeErrorBoundComponent, generateId } from '@els/els-react--utils';
import Case from 'case';
import PT from 'prop-types';
var bool$1 = PT.bool,
  func$1 = PT.func,
  node$1 = PT.node,
  object = PT.object,
  oneOf$1 = PT.oneOf,
  string$1 = PT.string;
var DropdownButton = /*#__PURE__*/function (_PureComponent) {
  function DropdownButton() {
    _classCallCheck(this, DropdownButton);
    return _callSuper(this, DropdownButton, arguments);
  }
  _inherits(DropdownButton, _PureComponent);
  return _createClass(DropdownButton, [{
    key: "render",
    value: function render() {
      var _flyoutRef$current;
      var _this$props = this.props,
        children = _this$props.children,
        disabled = _this$props.disabled,
        flyoutRef = _this$props.flyoutRef,
        iconLeft = _this$props.iconLeft,
        iconSprite = _this$props.iconSprite,
        id = _this$props.id,
        onClick = _this$props.onClick,
        showIcon = _this$props.showIcon,
        shouldHideLabel = _this$props.shouldHideLabel,
        trigger = _this$props.trigger,
        buttonProps = _objectWithoutProperties(_this$props, _excluded);
      var sharedProps = {
        active: trigger === "button" && buttonProps["aria-expanded"],
        "data-testid": "dropdown-button",
        disabled: disabled,
        onClick: onClick,
        size: trigger === "button" ? "x-small" : null,
        type: trigger === "button" ? "tertiary" : Button.Types.LINK
      };
      if (id) {
        sharedProps.id = id;
      }
      var orientedSprite = iconSprite === "ChevronDown" && flyoutRef !== null && flyoutRef !== void 0 && (_flyoutRef$current = flyoutRef.current) !== null && _flyoutRef$current !== void 0 && _flyoutRef$current.isVisible() ? Icon.Sprites.CHEVRON_UP : iconSprite;
      return showIcon ? /* @__PURE__ */React.createElement(ButtonWithIcon, _objectSpread(_objectSpread(_objectSpread({}, sharedProps), buttonProps), {}, {
        sprite: orientedSprite,
        iconRight: !iconLeft,
        iconOnly: shouldHideLabel,
        isDecorative: true
      }), children) : /* @__PURE__ */React.createElement(Button, _objectSpread(_objectSpread({}, sharedProps), buttonProps), children);
    }
  }]);
}(PureComponent);
DropdownButton.displayName = "DropdownButton";
DropdownButton.propTypes = {
  children: node$1.isRequired,
  className: string$1,
  disabled: bool$1,
  flyoutRef: object.isRequired,
  iconLeft: bool$1,
  iconSprite: oneOf$1(Object.values(Icon.Sprites)).isRequired,
  id: string$1,
  shouldHideLabel: bool$1,
  showIcon: bool$1,
  trigger: string$1,
  onClick: func$1
};
DropdownButton.defaultProps = {
  className: null,
  disabled: false,
  iconLeft: false,
  id: null,
  onClick: function onClick() {},
  shouldHideLabel: false,
  showIcon: true,
  trigger: "link"
};
var arrayOf = PT.arrayOf,
  bool = PT.bool,
  func = PT.func,
  node = PT.node,
  oneOf = PT.oneOf,
  shape = PT.shape,
  string = PT.string;
var optionShape = shape({
  // Required _unless_ render is supplied
  label: string,
  id: string,
  onClick: func,
  render: func,
  disabled: bool
});
var Dropdown = /*#__PURE__*/function (_PureComponent2) {
  function Dropdown() {
    var _this;
    _classCallCheck(this, Dropdown);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Dropdown, [].concat(args));
    _defineProperty(_this, "flyoutRef", createRef());
    _defineProperty(_this, "focusHandler", function (event) {
      var shouldCloseOnESC = _this.props.shouldCloseOnESC;
      var isVisible = _this.flyoutRef.current.state.isVisible;
      var isTabbingAway = event.key === "Tab" && isVisible && event.target.parentNode.getAttribute("data-testid") !== "dropdown-option-container";
      var isEscaped = shouldCloseOnESC && (event.key === "Escape" || event.key === "Esc") && isVisible;
      if (isTabbingAway || isEscaped) {
        _this.flyoutRef.current.toggleVisibility(false);
      }
    });
    /**
     * This function checks if Arrays of same length differ in values.
     *
     * @param {Object[]} oldOptions - A list of option objects
     * @param {Object[]} newOptions - A list of option objects
     * @return {boolean}
     *
     * @example
     *   // returns true
     *   doOptionsDiffer([{ops: "Options1"}], [{ops:"Options2"}])
     *
     * @example
     *   // returns false
     *   doOptionsDiffer([{ops: "Options1"}], [{ops: "Options1"}])
     *
     */
    _defineProperty(_this, "doOptionsDiffer", function (oldOptions, newOptions) {
      return oldOptions.some(function (option, index) {
        var oldOptionValuesArray = Object.keys(option);
        var newOptionValuesArray = Object.keys(newOptions[index]);
        var isOptionShapeSame = _this.checkIfOptionShapeisSame(oldOptionValuesArray, newOptionValuesArray);
        var doOptionsDiffer = !isOptionShapeSame ||
        // Checks if option Object differs in values when the shape is same
        oldOptionValuesArray.some(function (value) {
          var oldOptionValue = option[value];
          var newOptionValue = newOptions && newOptions[index] && newOptions[index][value];
          var areSameType = _typeof(oldOptionValue) === _typeof(newOptionValue);
          var isValueEqual = areSameType && oldOptionValue.toString() === newOptionValue.toString();
          return !isValueEqual;
        });
        return doOptionsDiffer;
      });
    });
    _defineProperty(_this, "checkIfOptionShapeisSame", function (oldOptionValuesArray, newOptionValuesArray) {
      return oldOptionValuesArray.length === newOptionValuesArray.length && oldOptionValuesArray.every(function (value) {
        return newOptionValuesArray.includes(value);
      });
    });
    _defineProperty(_this, "handleOptionClick", function (option) {
      var _this$props2 = _this.props,
        onChange = _this$props2.onChange,
        name = _this$props2.name;
      var onClick = option.onClick;
      onChange ? onChange(option, name) : null;
      onClick ? onClick(option, name) : null;
      _this.closeFlyout();
    });
    _defineProperty(_this, "closeFlyout", function () {
      return _this.flyoutRef.current.toggleVisibility(false);
    });
    _defineProperty(_this, "renderDropdownListItem", function (option, numberOfOptions, index) {
      var _this$props3 = _this.props,
        selected = _this$props3.selected,
        onChange = _this$props3.onChange;
      var render = option.render,
        label = option.label,
        id = option.id,
        className = option.className,
        onClick = option.onClick,
        props = _objectWithoutProperties(option, _excluded2);
      var isSelected = selected && option.label === selected.label;
      var itemId = id || Case.kebab("".concat(label, " ").concat(generateId()));
      var isLastItem = numberOfOptions === index + 1;
      var optionClassName = isLastItem ? null : "u-els-margin-bottom-1o2";
      return /* @__PURE__ */React.createElement("li", {
        className: className,
        key: itemId,
        id: itemId,
        "data-testid": "dropdown-option-container"
      }, /* eslint-disable-next-line no-nested-ternary */
      render ? render(_objectSpread(_objectSpread({}, props), {}, {
        closeFlyout: _this.closeFlyout
      })) : (onClick || onChange) && !isSelected ? /* @__PURE__ */React.createElement(Button, {
        className: optionClassName,
        onClick: _this.handleOptionClick.bind(_this, option),
        type: "link"
      }, label) : /* @__PURE__ */React.createElement("div", {
        className: optionClassName,
        "data-testid": "dropdown-option"
      }, label));
    });
    _defineProperty(_this, "renderDropdownList", function (options) {
      return /* @__PURE__ */React.createElement("ul", {
        "data-testid": "dropdown-container",
        key: generateId()
      }, options.map(function (option, index) {
        return _this.renderDropdownListItem(option, options.length, index);
      }));
    });
    return _this;
  }
  _inherits(Dropdown, _PureComponent2);
  return _createClass(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keyup", this.focusHandler);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      var oldOptions = oldProps.options;
      var newOptions = this.props.options;
      var isOptionsLengthEqual = (Array.isArray(oldOptions) && oldOptions.length) === (Array.isArray(newOptions) && newOptions.length);
      var shouldUpdateFlyout = !isOptionsLengthEqual || this.doOptionsDiffer(oldOptions, newOptions);
      if (shouldUpdateFlyout) {
        this.flyoutRef.current.update();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keyup", this.focusHandler);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        className = _this$props4.className,
        disabled = _this$props4.disabled,
        flyoutProps = _this$props4.flyoutProps,
        id = _this$props4.id,
        iconLeft = _this$props4.iconLeft,
        iconSprite = _this$props4.iconSprite,
        label = _this$props4.label,
        options = _this$props4.options,
        selected = _this$props4.selected,
        shouldHideLabel = _this$props4.shouldHideLabel,
        showIcon = _this$props4.showIcon,
        showSelectedAsLabel = _this$props4.showSelectedAsLabel,
        trigger = _this$props4.trigger;
      return /* @__PURE__ */React.createElement(Flyout, _objectSpread({
        placement: "bottom-start",
        pointerType: "primary",
        id: id,
        ref: this.flyoutRef,
        className: className,
        flyout: this.renderDropdownList(options),
        isControlled: disabled,
        isOpen: false
      }, flyoutProps), /* @__PURE__ */React.createElement(DropdownButton, {
        id: id ? "".concat(id, "-button") : null,
        iconSprite: iconSprite,
        disabled: disabled,
        trigger: trigger,
        showIcon: showIcon,
        iconLeft: iconLeft,
        shouldHideLabel: shouldHideLabel,
        flyoutRef: this.flyoutRef
      }, selected && showSelectedAsLabel ? selected.label : label));
    }
  }]);
}(PureComponent);
Dropdown.displayName = "Dropdown";
Dropdown.propTypes = {
  className: string,
  disabled: bool,
  // Not going to define the shape here as it's the same as the Flyout prop set
  flyoutProps: shape({}),
  iconLeft: bool,
  iconSprite: oneOf(Object.values(Icon.Sprites)),
  id: string,
  label: node,
  name: string,
  options: arrayOf(optionShape).isRequired,
  selected: optionShape,
  shouldCloseOnESC: bool,
  /** Determines if the label is shown or not */
  shouldHideLabel: bool,
  showIcon: bool,
  showSelectedAsLabel: bool,
  trigger: string,
  onChange: func
};
Dropdown.defaultProps = {
  className: "",
  disabled: false,
  flyoutProps: null,
  label: "Select",
  iconLeft: false,
  iconSprite: Icon.Sprites.CHEVRON_DOWN,
  id: null,
  name: "",
  selected: null,
  showIcon: true,
  shouldCloseOnESC: true,
  shouldHideLabel: false,
  showSelectedAsLabel: true,
  trigger: "link",
  onChange: null
};
Dropdown.requiredProps = {
  options: ValidPropTypes.ARRAY
};
var RawDropdown = Dropdown;
var Dropdown$1 = makeErrorBoundComponent(RawDropdown);
export { Dropdown$1 as Dropdown, RawDropdown };
